export default "__VITE_ASSET__LrtSljkb__";